module.exports = __webpack_public_path__ + "img/funds-box-fill.e6a28abc.svg";